import { Tile } from '../atom.tile/_tile-input.js';
import { tile } from './atom.tile.style.js';
import { jsx } from 'react/jsx-runtime';

function PlaceItemsInTextTile(props) {
  return /*#__PURE__*/jsx(Tile, {
    className: tile,
    size: "thin",
    preferredFlow: "row",
    facitTheme: "colored-backgrounds",
    tile: props.tile,
    state: props.state,
    isDraggable: !!props.isDraggable,
    isDragOverlay: !!props.isDragOverlay
  });
}

export { PlaceItemsInTextTile };
//# sourceMappingURL=atom.tile.js.map
